import { Link as LinkIcon } from "lucide-react";
import { CopyMenuItem } from "./CopyMenuItem";
import { TURN_PARAM } from "./useAnchoredScroll";

interface CopyTurnLinkButtonProps {
  // Root turn anchor id (already normalized via `turnAnchorId`); becomes the
  // `?turnId=` deep-link target.
  turnId: string;
}

// Permalink to this turn built from the current location, dropping any existing
// query so the link carries only the turn target. Origin + pathname keeps it
// correct across all three surfaces (regular / shared / admin), whose routes
// differ.
const buildTurnUrl = (turnId: string) =>
  `${window.location.origin}${window.location.pathname}?${TURN_PARAM}=${encodeURIComponent(turnId)}`;

// "Copy link to turn" action rendered as a row inside the turn actions menu.
export const CopyTurnLinkButton = ({ turnId }: CopyTurnLinkButtonProps) => (
  <CopyMenuItem
    getText={() => buildTurnUrl(turnId)}
    idleLabel="Copy link to turn"
    icon={LinkIcon}
    successMessage="Link copied"
  />
);
